export default "__VITE_ASSET__CHVUYVDo__"